import React from 'react';
import { EmptySearchColor, EmptyDefaultColor } from 'patternx-svg';
import classNames from 'classnames';
import styles from './index.module.less';

export type EmptyProps = React.PropsWithChildren<{
  isEmpty?: boolean; // 数据是否为空
  icon?: React.ReactNode;
  iconSize?: number;
  imgSrc?: string;
  describe?: string;
  subDescribe?: string;
  size?: number;
  btnClick?: (e: React.MouseEvent) => void;
  btnRender?: () => JSX.Element | undefined | boolean;
  wrapStyle?: any;
  [propName: string]: any;
}>;
const PtxEmpty: React.FC<EmptyProps> = (props: EmptyProps) => {
  const {
    icon = <EmptyDefaultColor />,
    isEmpty,
    describe,
    subDescribe,
    size = 200,
    btnRender,
    describeStyle = {},
    subDescribeStyle = {},
    wrapStyle,
  } = props;
  return (
    <div className={styles.emptyWrap} style={wrapStyle}>
      <div className={styles.emptyIcon}>{!isEmpty ? <EmptySearchColor size={size} /> : icon}</div>
      <div
        style={{ ...describeStyle }}
        className={classNames(styles.describe, { [styles.small]: size <= 120 })}
      >
        {!isEmpty ? '没有找到相关结果' : describe || '没有数据'}
      </div>
      {!isEmpty && (
        <div
          className={classNames(styles.subDescribe, { [styles.small]: size <= 120 })}
          style={{ ...subDescribeStyle }}
        >
          尝试换一个关键词或搜索范围
        </div>
      )}
      {isEmpty && subDescribe && (
        <div
          className={classNames(styles.subDescribe, { [styles.small]: size <= 120 })}
          style={{ ...subDescribeStyle }}
        >
          {subDescribe}
        </div>
      )}

      <div className={styles.buttons}>{btnRender?.()}</div>
    </div>
  );
};

export default PtxEmpty;
